import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'course-session-enrollments'
const initialState = {
  list: null,
  loading: false,
}

export const search = createApiAction(
  'scheduling/course-session-enrollment/search',
  client.search('/api/scheduling/course-session/:courseSessionId/enrollment'),
)

export const save = createApiAction(
  'scheduling/course-session-enrollment/create',
  client.save('/api/scheduling/course-session/:courseSessionId/enrollment'),
)

export const get = createApiAction(
  'scheduling/course-session-enrollment/get',
  client.retrieve(`/api/scheduling/course-session/:courseSessionId/enrollment/:id`),
)

export const update = createApiAction(
  'scheduling/course-session-enrollment/save',
  client.save('/api/scheduling/course-session/:courseSessionId/enrollment'),
)

export const destroy = createApiAction(
  'scheduling/course-session-enrollment/delete',
  client.destroy('/api/scheduling/course-session/:courseSessionId/enrollment/:id'),
)

const updateList = (state, action) => {
  const found = state.list?.find(rec => rec.id === action.payload.id)
  if (found) {
    state.list = state.list.map(item => (item.id === action.payload.id ? action.payload : item))
  } else {
    state.list = state.list ? [...state.list, action.payload] : [action.payload]
  }
}

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    reset: state => {
      state.list = []
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, (state) => {
        state.loading = true
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
        state.loading = false
      })
      .addCase(get.fulfilled, updateList)
      .addCase(save.fulfilled, updateList)
      .addCase(update.fulfilled, updateList)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state?.list?.filter(item => item.id !== action.payload.id)
      })
  },
})
export const { reset } = sessionSlice.actions
export default sessionSlice.reducer
